import React from "react";
import { Field } from "../Field/Field";
import { Input } from "reactstrap";
import style from "./Precheck.module.scss";

const Authorization = ({ authorization, changeMessage }) => {
  const { error, readonly } = authorization;

  return (
    <div className={style.authorization}>
      <p>{authorization.name}</p>
      <Field error={error} noLabel>
        <Input
          className={style.input}
          type={"textarea"}
          rows={2}
          placeholder={"Message"}
          value={authorization.text || ""}
          style={{ marginTop: "5px" }}
          invalid={!!error}
          disabled={!!readonly}
          onChange={(e) => changeMessage(authorization.name, e.target.value)}
        />
      </Field>
    </div>
  );
};

export default Authorization;
